import Accordion from '../../plugins/accordion.js';
const elements = document.querySelectorAll(".js-accordion");
let accordion = "";
for (const element of elements) {
  accordion = new Accordion(element, {
    defaultOpenPanels: [0],
    duration: '.3s',
    multipleOpen: true
  });
}


let isSP = false;

const setFlug = () => {
  let windowWidth = window.innerWidth
  return windowWidth < 1024 ? true : false
}

const accordionSwitch = () => {
  isSP = setFlug()
  if (isSP) {
    accordion.init()
  } else {
    accordion.destroy()
  }
}

isSP = setFlug()
accordionSwitch()

window.addEventListener("resize", accordionSwitch)


